import React from 'react';
import { Button } from '@mui/material';
import styled from 'styled-components';

const ChipWithIcons = styled(({ label, onClick, ...props }) => (
  <Button {...props} variant="outlined" onClick={onClick}>
    {label}
  </Button>
))`
  && {
    color: ${(props) => props.$textColor || props.theme.palette.colors.black};
    border-radius: 18px;
    border: ${({ border }) =>
      border ? border : `1px solid ${({theme}) => theme.palette.colors.gray200}`};
    background: ${({ background, theme }) =>
      background ? background : theme.palette.colors.gray100};
    margin: ${({ margin }) => (margin ? margin : '0')};
    min-width: 42px;
    max-width: 300px;
    height: 42px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export default React.memo(ChipWithIcons);
